/* unplugin-vue-components disabled */import { render } from "./w-search-bar.vue?vue&type=template&id=77f4b76a&scoped=true&ts=true"
import script from "./w-search-bar.vue?vue&type=script&lang=ts"
export * from "./w-search-bar.vue?vue&type=script&lang=ts"

import "./w-search-bar.vue?vue&type=style&index=0&id=77f4b76a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f4b76a"]])

export default __exports__